import React, { useEffect, useContext } from "react";
import { BranchesContext } from "../../context/BranchesContext";
import { ModalContext } from "../../context/ModalContext";
import BranchForm from "../../components/branches/BranchForm";

const AdminBranches = () => {
  const {
    branches,
    getBranches,
    setBranchForm,
    setPropertyBranch,
    saveBranch,
    createBranch,
    deleteBranch,
  } = useContext(BranchesContext);

  const { modalComponent, clearModal } = useContext(ModalContext);

  useEffect(() => {
    getBranches();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editBranch = (branch) => {
    setBranchForm(branch);
    modalComponent(
      "Editar Franquicia",
      <BranchForm
        modifier={setPropertyBranch}
        postBranch={(branchData) => {
          saveBranch(branchData, () => {
            getBranches();
          });
        }}
        handleCancel={clearModal}
      />
    );
  };

  const addBranch = () => {
    createBranch();
    modalComponent(
      "Agregar Franquicia",
      <BranchForm
        modifier={setPropertyBranch}
        postBranch={(branchData) => {
          saveBranch(branchData, getBranches);
        }}
        handleCancel={clearModal}
      />
    );
  };

  const confirmDelete = (branch) => {
    modalComponent(
      "Cuidado",
      <div className="container-fluid px-0">
        <p>
          ¿Estás segura que deseas eliminar la franquicia {branch.name}? Esta acción
          NO puede deshacerse.
        </p>
        <button
          className="btn btn-danger"
          onClick={() => deleteBranch(branch.branch_id, getBranches)}
        >
          Eliminar
        </button>
      </div>
    );
  };

  const renderBranches = () => {
    if (branches && branches !== null) {
      return branches.map((currentBranch) => (
        <tr
          key={currentBranch.branch_id}
          className="small bg-white border-bottom align-middle hover-light"
        >
          <td className="">{currentBranch.name}</td>
          <td className="">{currentBranch.description}</td>
          <td className="text-center">
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => editBranch(currentBranch)}
            >
              <i className="fa fa-edit me-1"></i> Editar
            </button>
            <button
              className="btn btn-outline-danger btn-sm mx-3"
              onClick={() => confirmDelete(currentBranch)}
            >
              <i className="fa fa-trash me-2"></i> Eliminar
            </button>
          </td>
        </tr>
      ));
    }
    return <div className="spinner-border"></div>;
  };

  const renderContent = () => {
    if (branches?.length > 0) {
      return (
        <div className="table-responsive">
          <table className="table border">
            <thead className="bg-light border bold small">
              <tr className="bold mx-0 border align-items-center">
                <td>Nombre</td>
                <td>Descripción</td>
                <td className="text-center">Acciones</td>
              </tr>
            </thead>
            <tbody>{renderBranches()}</tbody>
          </table>
        </div>
      );
    } else {
      return <p className="bold">No existen Franquicias registradas.</p>;
    }
  };

  return (
    <div className="container-fluid">
      <div className="row border-bottom pb-3 mb-3">
        <div className="col col-md-6">
          <h1>Franquicias</h1>
        </div>
        <div className="col col-md-6 text-end">
          <button className="btn btn-primary" onClick={addBranch}>
            + Agregar
          </button>
        </div>
      </div>

      <div className="card p-3 shadow">{renderContent()}</div>
    </div>
  );
};

export default AdminBranches;
